import {connect} from 'react-redux';
import * as VideoActions from '../../store/actions/videoActions';
import VideoEdit from '../../components/EditChapterPart/VideoEdit';


const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    loadBlank: () => {
        dispatch(VideoActions.loadBlankVideo());
    },
    loadVideoById: (id, token) => {
        //dispatch(VideoActions.loadVideoById(id, token));
    },
    uploadVideo: (file, chapterPartId, duration, token) => {
        dispatch(VideoActions.uploadVideo(file, chapterPartId, duration,  token));
    },
    uploadVideoCreate: (file, lecture, duration, token) => {
        lecture.status = false;
        dispatch(VideoActions.uploadVideoCreate(file, lecture, duration, token));
    },
    deleteVideo: (file, token) => {
        dispatch(VideoActions.deleteVideo(file, token));
    },
    setInitialVideo: (file, token) => {
        dispatch(VideoActions.internalVideoUpdate(file, token));
    },
    uploadSubtitles: (file, videoId, token) => {
        dispatch(VideoActions.uploadSubtitles(file, videoId, token));
    }
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VideoEdit);


// WEBPACK FOOTER //
// ./src/containers/EditChapterPart/VideoEditContainer.js